import type { Theme } from '@mui/material';

import { OptumDefault } from '../utils/theme/OptumDefault';

import getExternalTheme from './external-theme';
import type { getThemeArgs } from './external-theme/types';
import type { FontSources } from './external-theme/appearance/types';

const getTheme: (args?: getThemeArgs) => Theme = ({
  theme = OptumDefault,
  appearance,
} = {}) => {
  if (appearance) {
    return getExternalTheme({ theme, appearance });
  }
  return theme;
};

export interface FontStyles {
  fontSources: FontSources;
}

export default getTheme;
